@if (isCartSticky) {
  <section class="scheduler-section cart-section"
    [ngClass]="isCartSticky === true ? 'cart-sticky' : 'cart-hide-header'">
    <div class="d-flex justify-content-center marginBottom">
      @if (!isCalendarViewOnly) {
        <div class="stickyStatus">
          @if (schedulerStatus=='All units and doses have been scheduled') {
            <div>
              <img src="/icons/confirmation-positive-green.png"/>
            </div>
          }
          @if (schedulerStatus=='Exceeds Total') {
            <div class="mt-3">
              <div class="text-center">Exceeds Total</div>
              <div class="text-center">Remove from calendar</div>
            </div>
          }
          @if (schedulerStatus != 'Exceeds Total') {
            <div [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled'}"
              >{{schedulerStatus}}
            </div>
          }
        </div>
      }
      @if (!isCalendarViewOnly) {
        <div class="scheduler sticky-scheduler">
          @if ((schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')) {
            <div class="units-doses mt-2">
              <div>
                <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingUnits)}}</div>
                <div>units</div>
              </div>
              <span>|</span>
              <div>
                <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingDoses)}}</div>
                <div>Doses</div>
              </div>
            </div>
          }
        </div>
      }
      @if (!isCalendarViewOnly && stsProductsJoinedList?.length >0) {
        <div class="d-flex align-items-center plpbutton-header ml-2 mt-3">
          <button type="button" class="btn-primary mr-2 btn-small-sts" [disabled]="!isCalendarUpdated || thresholdError" (click)="saveChanges()">
            Save changes
          </button>
          <button type="button" class="btn-secondary schdl-later btn-small-sts" [disabled]="!isCalendarUpdated" (click)="cancelChanges()">
            Cancel changes
          </button>
        </div>
      }
    </div>
    @if (stsProductsJoinedList?.length >0) {
      <div class="col-lg-12 col-md-12 col-sm-12 frequencyItems align-frequency product-sticky">
        <div class="col-lg-11 col-md-12 col-sm-12 cart" >
          @for (stsProdData of stsProductsJoinedList; track stsProdData; let i = $index) {
            <div class="eachItemFrequency product">
              <span class="prod-no">{{stsProdData.materialNum}}</span>
              <span class="frequencyItemHead">
                <a (click)="productDetails(stsProdData)" title="{{stsProdData?.name}}"  class="cart_title">
                  <p class="prod-des" [innerHTML]="stsProdData?.variantProductDescription"></p>
                </a>
              </span>
              <div class="selectFreq">
                <ng-select bindLabel="name" bindValue="code"
                  [multiple]="false"
                  [(ngModel)]="stsProdData.selectedFreq"
                  name="{{'frequencyList'+stsProdData?.materialNum}}"
                  placeholder="Select frequency"
                  (change)="frequencyChange($event,stsProdData)"
                  [disabled]="isCalendarViewOnly">
                  @for (freq of stsProdData.frequencyList; track freq) {
                    <ng-option
                    [value]="freq.code">{{freq.name}}</ng-option>
                  }
                </ng-select>
              </div>
              @if (stsProdData?.quantity > 0) {
                <span class="freqRemainScdle">Remaining to schedule</span>
              }
              @if (stsProdData?.quantity == 0 ) {
                <span class="freqRemainScdle">Scheduled</span>
              }
              @if (stsProdData?.quantity < 0) {
                <span class="freqRemainScdle">Remove from calendar</span>
              }
              @if (stsProdData?.quantity > 0) {
                <span class="freqUnits sched-freq">{{stsProdData?.quantity}} Units | {{stsProdData?.quantity * stsProdData?.quantityPerUnit}} Doses</span>
              }
              @if (stsProdData?.quantity == 0) {
                <span class="freqUnits sched-freq success">{{stsProdData?.productQuantityValue}} Units | {{stsProdData?.productQuantityValue * stsProdData?.quantityPerUnit}} Doses</span>
              }
              @if (stsProdData?.quantity < 0) {
                <span class="freqUnits sched-freq error">{{myMath.abs(stsProdData?.quantity)}} Units | {{myMath.abs(stsProdData?.quantity) * stsProdData?.quantityPerUnit}} Doses</span>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (updateFreqFlag) {
      <div class="non-sticky update-calendar sticky-calendar updateRow marginTop">
        <div class="headTxt">Update the calendar with your frequency selections.</div>
        <button type="button" class="btn btn-primary updateCal" (click)="updateCalendar()">
          Update Calendar
        </button>
        <button type="button" class="btn btn-secondary cancelCal" (click)="cancelUpdateCalendar()">
          Cancel
        </button>
      </div>
    }
  </section>
}

<div class="container-fluid" id="main-Container">

  <div class="row">
    <section class="scheduler-section">
      <div class="row">
        <div class="col-md-5 col-lg-5 col-sm-12 scheduler-content">
          @if (isCalendarViewOnly) {
            <div class="lock-text" [innerHTML] = "lockMessage"></div>
          }
          @if (headerContent) {
            <div class="headline-text" [innerHTML] = "headerMessage"></div>
          }
          <ng-template #headerContentSample>
            <h3><strong>Set your own Shipping Schedule &nbsp;Optional</strong></h3>
          </ng-template>

          @if (programContent) {
            <div class="program-text" [innerHTML] = "programMessage"></div>
          }
          <ng-template #programContentSample>
            <p>This is a&nbsp;Business configurable -&nbsp; RSD. It sets up messaging below.</p>
          </ng-template>
          @if (quickContent) {
            <div class="quick-text" [innerHTML] = "quickMessage"></div>
          }
        </div>
        @if (!isCalendarViewOnly) {
          <div class="col-md-3 col-lg-3 col-sm-12">
            <div class="scheduler">
              @if (schedulerStatus=='All units and doses have been scheduled') {
                <div>
                  <img src="/icons/confirmation-positive-green.png"/>
                </div>
              }
              @if (schedulerStatus=='Exceeds Total') {
                <div>
                  <div class="text-center">Exceeds Total</div>
                  <div class="text-center">Remove from calendar</div>
                </div>
              }
              @if (schedulerStatus != 'Exceeds Total') {
                <div [ngClass]="{'unit-scheduled':schedulerStatus=='All units and doses have been scheduled'}"
                  >{{schedulerStatus}}
                </div>
              }
              @if ((schedulerStatus=='Remaining to schedule' || schedulerStatus=='Exceeds Total')) {
                <div class="units-doses mt-2"
                  >
                  <div>
                    <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingUnits)}}</div>
                    <div>units</div>
                  </div>
                  <span>|</span>
                  <div>
                    <div [ngClass]="{'exceeds-style':schedulerStatus=='Exceeds Total'}">{{myMath.abs(remainingDoses)}}</div>
                    <div>Doses</div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (isCalendarViewOnly) {
          <div class="col-md-3 col-lg-3 col-sm-12 locked-div">
          </div>
        }
        @if (!isCalendarViewOnly && stsProductsJoinedList?.length >0) {
          <div class="col-md-4 col-lg-4 col-sm-12">
            <section class="plpbutton2">
              <button type="button" class="btn-primary btn-small-sts" [disabled]="!isCalendarUpdated || thresholdError" (click)="saveChanges()">
                Save changes
              </button>
              <br />
              <button type="button" class="btn-secondary schdl-later btn-small-sts" [disabled]="!isCalendarUpdated" (click)="cancelChanges()">
                Cancel changes
              </button>
            </section>
          </div>
        }
      </div>
      @if (stsProductsJoinedList?.length >1) {
        <div class="col-sm-12 col-md-12 no-xs visible-xs visible-sm">
          <strong>Not optimized for mobile devices.</strong> <br>
          <span>We recommend viewing this page on larger screens for a better experience.
          </span>
        </div>
      }
    </section>
  </div>

  <!--Shipping Frequency and products section -->
  @if (stsProductsJoinedList?.length >0) {
    <div class="row">
      <section class="scheduler-section cart-section">
        <div>
          <p>
            <img class="mr-2" src="/icons/{{baseSiteId}}/shipping.png" alt="" />Shipping Frequency
          </p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 frequencyItems align-frequency">
          <div class="col-lg-11 col-md-12 col-sm-12 cart pl-4" >
            @for (stsProdData of stsProductsJoinedList; track stsProdData; let i = $index) {
              <div class="eachItemFrequency product">
                <div class="imgContainer">
                  @if (stsProdData?.thumbNailImg && stsProdData?.thumbNailImg!== '') {
                    <img
                      src="{{baseUrl}}{{stsProdData?.thumbNailImg}}"
                      title="{{stsProdData?.name}}" alt=""/>
                  }
                  @if (!stsProdData?.thumbNailImg || stsProdData?.thumbNailImg == '') {
                    <img
                      src="/img/missing_product_EN_300x300.jpg"
                      title="{{stsProdData?.name}}" alt=""/>
                  }
                </div>
                <span class="prod-no">{{stsProdData.materialNum}}</span>
                <span class="frequencyItemHead">
                  <a (click)="productDetails(stsProdData)" title="{{stsProdData?.name}}"  class="cart_title">
                    <p class="prod-des" [innerHTML]="stsProdData?.variantProductDescription"></p>
                  </a>
                </span>
                <div class="selectFreq">
                  <ng-select bindLabel="name" bindValue="code"
                    [multiple]="false"
                    [(ngModel)]="stsProdData.selectedFreq"
                    name="{{'frequencyList'+stsProdData?.materialNum}}"
                    placeholder="Select frequency"
                    (change)="frequencyChange($event,stsProdData)"
                    [disabled]="isCalendarViewOnly">
                    @for (freq of stsProdData.frequencyList; track freq) {
                      <ng-option
                      [value]="freq.code">{{freq.name}}</ng-option>
                    }
                  </ng-select>
                </div>
                <!--below 2 will change based on user's action, then will apply conditions.
                currently as per new reservation case once user lands on the page
                quantity as remaining scheduled quantity (will change on user's action)
                productQuantityValue as original quantity (will not change)-->
                @if (stsProdData?.quantity > 0) {
                  <span class="freqRemainScdle">Remaining to schedule</span>
                }
                @if (stsProdData?.quantity == 0 ) {
                  <span class="freqRemainScdle">Scheduled</span>
                }
                @if (stsProdData?.quantity < 0) {
                  <span class="freqRemainScdle">Remove from calendar</span>
                }
                @if (stsProdData?.quantity > 0) {
                  <span class="freqUnits sched-freq">{{stsProdData?.quantity}} Units | {{stsProdData?.quantity * stsProdData?.quantityPerUnit}} Doses</span>
                }
                @if (stsProdData?.quantity == 0) {
                  <span class="freqUnits sched-freq success">{{stsProdData?.productQuantityValue}} Units | {{stsProdData?.productQuantityValue * stsProdData?.quantityPerUnit}} Doses</span>
                }
                @if (stsProdData?.quantity < 0) {
                  <span class="freqUnits sched-freq error">{{myMath.abs(stsProdData?.quantity)}} Units | {{myMath.abs(stsProdData?.quantity) * stsProdData?.quantityPerUnit}} Doses</span>
                }
              </div>
            }
          </div>
        </div>
        @if (updateFreqFlag) {
          <div class="non-sticky update-calendar sticky-calendar updateRow marginTop">
            <div class="headTxt">Update the calendar with your frequency selections.</div>
            <button type="button" class="btn btn-primary updateCal" (click)="updateCalendar()">
              Update Calendar
            </button>
            <button type="button" class="btn btn-secondary cancelCal" (click)="cancelUpdateCalendar()">
              Cancel
            </button>
          </div>
        }
      </section>
    </div>
  }

  <!--Calendar and units section -->
  @if (stsProductsJoinedList?.length >0) {
    <div class="row units-section">
      @if (updateFreqFlag) {
        <div class="calendar-overlay"></div>
      }
      @for (month of monthsList; track month; let m = $index) {
        <section class="scheduler-section ship-immediate">
          <div class="row align-items-center mb-4">
            <div class="col-md-3">
              <img class="mr-1" src="/icons/{{baseSiteId}}/calendar.svg" alt="" /><span class="cal-month">{{month?.monthyear}}</span>
            </div>
            <div class="col-md-4 d-flex align-items-center">
            </div>
            <div class="col-md-5 d-flex align-items-center justify-content-end shipimmediate-total">
              <span class="mr-2">Total Units</span>
              <!--below units & doses have to be calculated for sum of both the products-->
              <span id="{{'stsMonthUnits-'+m}}">{{month?.totalUnits}}</span><span class="ml-1 mr-2">Units</span>
              <span class="mr-2">|</span>
              <span class="mr-2" id="{{'stsMonthDoses-'+m}}">{{month?.totalDoses}}</span><span class="ml-1 mr-4">Doses</span>
              <span (click)="month.showUnits = !month.showUnits" class="ml-3">
                @if (month?.showUnits == false) {
                  <img src="/icons/{{baseSiteId}}/plus-green.png" class="plusminus-icon"/>
                }
                @if (month?.showUnits == true) {
                  <img src="/icons/{{baseSiteId}}/minus-green.png" class="plusminus-icon"/>
                }
              </span>
            </div>
          </div>
          @if (month?.showUnits) {
            <div class="showunits-parent">
              <div class="show-units-yes"><div class="material-title"></div>
              @for (stsData1 of stsReservationList; track stsData1; let n1 = $index) {
                @for (materialData of stsData1?.materialSchedule; track materialData; let o1 = $index) {
                  @if (materialData?.stsMonthYear == month?.monthyear) {
                    @for (week of materialData?.weekList; track week; let w1 = $index) {
                      @if (n1==0) {
                        <div class="week-card">
                          <span class="weekLabel">Week</span>
                          <!-- <br/> -->
                          <span class="weekNumber">{{ transformWeek(week?.startMonday)}}</span>
                        </div>
                      }
                    }
                  }
                }
              }
            </div>
            @for (stsData2 of stsProductsJoinedList; track stsData2; let n2 = $index) {
              <div class="material-items"><div class="material-title">Requested</div>
              @for (materialData2 of stsData2?.materialSchedule; track materialData2; let o2 = $index) {
                @if (materialData2?.stsMonthYear == month?.monthyear) {
                  @for (week2 of materialData2?.weekList; track week2; let w2 = $index) {
                    <div class="unit-card">
                      <span [hidden]="true"
                        id="{{'exceedsPopoverOpen-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
                      (click)="openPopover(exceedsPopover1)"></span>
                      <span [hidden]="true"
                        id="{{'exceedsPopoverClose-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
                      (click)="closePopover(exceedsPopover1)"></span>
                      <span>Units</span>
                      <input type="number" class="prod-quantity text-center"
                        (keypress)="numberCheck($event)"
                        (blur)="checkBlank($event)"
                        id="{{'stsinput-'+stsData2?.materialNum+'-'+m+'-'+w2}}"
                        [(ngModel)]="week2.finalQty" max="9999" min="0"
                        [disabled]="!week2?.weekEnable||isCalendarViewOnly"
                        [ngbPopover]="exceedsTooltip"
                        triggers="manual" #exceedsPopover1="ngbPopover"
                        placement="top"
                        popoverClass="popover-links stsExceedsPopover"
                        [autoClose]="false"
                        (keyup)="performQuantityUpdation($event,stsData2?.materialNum, week2, w2,m)"
              [ngClass]="{'unit-success':week2.finalQty > 0 && !week2.showpopover,
                          'unit-error': week2.finalQty > 0 && week2.showpopover}"/>

              @if (week2.finalQty >0) {
<div class="sts-unit-doses" id="{{ 'stsdoses-'+stsData2?.materialNum+'-'+week2?.startMonday}}"
             
              [ngClass]="{'doses-error':week2.finalQty > 0 && week2.showpopover}">{{week2.finalQty * stsData2?.quantityPerUnit}} Doses</div>
                      }
                    </div>
                    <ng-template #exceedsTooltip>
                      <div class="exceedsContent">
                        <div class="imgBlock">
                          <img src="/icons/{{baseSiteId}}/warning_red_new.png" class="positive-green-icon"
                            alt="success">
                        </div>
                        <div class="contentBlock">
                          <span class="exceedsMsg">
                            Exceeds limit <br/>
                            Please reduce your<br/>
                            units/doses.
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  }
                }
              }
            </div>
            @if (n2 + 1 === stsProductsJoinedList?.length) {
              <div class="weeks-items"><div class="material-title"></div>
              @for (materialData2 of stsData2?.materialSchedule; track materialData2; let o2 = $index) {
                @if (materialData2?.stsMonthYear == month?.monthyear) {
                  @for (week2 of materialData2?.weekList; track week2; let w2 = $index) {
                    <div class="empty-card"></div>
                  }
                }
              }
            </div>
          }
        }
      </div>
    }
  </section>
}
</div>
}
</div>
